module.exports = __webpack_public_path__ + "img/works_kdb_btm.c8af7809.jpg";